import "../styles/home.css";
import { SERVICES } from "../data/constants";
import { aboutTeam } from "../assets/images";

export default function Home({ navigate }) {
  return (
    <div>
      <div className="home__hero">
        <div className="home__hero-content">
          <p className="home__hero-eyebrow">Statesville, NC's Trusted Fleet Partner</p>
          <h1 className="home__hero-title">Keep Your Fleet <span>Rolling Strong</span></h1>
          <p className="home__hero-sub">Professional routine maintenance for commercial trucks — oil changes, chassis lubrication, and full cleaning services.</p>
          <div className="home__hero-actions">
            <button className="btn btn--primary" onClick={() => navigate("Contact")}>Request Service</button>
            <button className="btn btn--outline" onClick={() => navigate("Services")}>Our Services</button>
          </div>
        </div>
      </div>

      <div className="home__stats">
        <div className="home__stats-inner">
          {[["50+","Trucks Serviced"],["14+","Years Experience"],["100%","Satisfaction Goal"],["3","Core Services"]].map(([n, l]) => (
            <div key={l} className="home__stat">
              <div className="home__stat-number">{n}</div>
              <div className="home__stat-label">{l}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="home__about">
        <div className="home__about-text-block">
          <p className="home__about-eyebrow">WHO WE ARE</p>
          <h2 className="home__about-title">Maintenance You Can Count On</h2>
          <p className="home__about-text">Race City Truck Solutions was founded right here in the heart of the Lake Norman region with one simple mission: give commercial truck operators a reliable, no-hassle maintenance partner they can trust. We understand that downtime costs money, and we work hard to get your trucks in and out efficiently without cutting corners.</p>
          <p className="home__about-text">Whether you manage a single owner-operator rig or a large commercial fleet, we have the tools, experience, and commitment to keep every truck running at peak performance.</p>
        </div>
        <div className="home__about-img">
          <img src={aboutTeam} alt="truck maintenance" />
        </div>
      </div>

      <div className="home__services">
        <div className="home__services-inner">
          <div className="home__services-header">
            <p className="home__services-eyebrow">WHAT WE DO</p>
            <h2 className="home__services-title">Our Core Services</h2>
          </div>
          <div className="home__services-grid">
            {SERVICES.map((s) => (
              <div key={s.title} className="home__service-card">
                <img src={s.img} alt={s.title} />
                <div className="home__service-card-body">
                  <div className="home__service-card-icon">{s.icon}</div>
                  <h3 className="home__service-card-title">{s.title}</h3>
                  <p className="home__service-card-desc">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="home__cta">
        <h2 className="home__cta-title">Ready to Schedule Service?</h2>
        <p className="home__cta-sub">Fill out our quick contact form and we will get back to you promptly.</p>
        <button className="btn btn--cta" onClick={() => navigate("Contact")}>Get a Quote Today</button>
      </div>
    </div>
  );
}